var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3578_33760)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 0C2.68387 0 0 2.68352 0 6C0 9.31612 2.68352 12 6 12C9.31612 12 12 9.31648 12 6C12 2.68387 9.31648 0 6 0ZM6 11.2C3.13273 11.2 0.799992 8.8673 0.799992 6C0.799992 3.1327 3.13273 0.799992 6 0.799992C8.86727 0.799992 11.2 3.13273 11.2 6C11.2 8.86727 8.86727 11.2 6 11.2Z",
    fill: "#1D4E89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.84759 7.3125C5.56349 7.3125 5.3335 7.54922 5.3335 7.83334C5.3335 8.11065 5.55671 8.35417 5.84759 8.35417C6.13847 8.35417 6.36846 8.11065 6.36846 7.83334C6.36846 7.54922 6.1317 7.3125 5.84759 7.3125Z",
    fill: "#1D4E89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.93568 3.36719C5.02246 3.36719 4.60303 3.90834 4.60303 4.27358C4.60303 4.5374 4.82629 4.65915 5.00892 4.65915C5.37421 4.65915 5.22541 4.13831 5.91541 4.13831C6.25365 4.13831 6.52424 4.28711 6.52424 4.59828C6.52424 4.96353 6.14542 5.17325 5.92218 5.36261C5.72598 5.53173 5.46892 5.80906 5.46892 6.39081C5.46892 6.7425 5.56363 6.844 5.84097 6.844C6.17247 6.844 6.24011 6.69519 6.24011 6.56667C6.24011 6.21497 6.24686 6.01202 6.6189 5.72116C6.80157 5.57911 7.37656 5.11914 7.37656 4.48331C7.37656 3.84748 6.80157 3.36719 5.93568 3.36719Z",
    fill: "#1D4E89"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3578_33760"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.9229b643b8cc70bfbcc6bee6c18d6066.svg";
export { ForwardRef as ReactComponent };